<template>
  <panel-layout
    id="panel"
    :loading="loading"
    :heading="$t('pages.helpGuide.index.title')"
    :show-footer="false"
  >
    <template #actions-right>
      <o-tooltip class="h-8" :text="$t('pages.helpGuide.index.openInNewTab')">
        <a :href="linkUrl" target="_blank">
          <o-button flat icon="externalLink" />
        </a>
      </o-tooltip>
    </template>
    <div class="h-full">
      <iframe :src="frameUrl" frameborder="0" class="h-full w-full" />
    </div>
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

import { usePanel } from '~/composables/usePanel'

const panel = usePanel()

const props = defineProps<{ path?: string }>()

const loading = ref(true)

const frameUrl = computed(() => `https://help.ovatu.com/app/${props.path ?? ''}`)
const linkUrl = computed(() => `https://help.ovatu.com/${props.path ?? ''}`)

loading.value = false
</script>
